var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.30649 3.38094C4.39512 3.34986 4.48836 3.33398 4.58228 3.33398H15.4156C15.5095 3.33398 15.6028 3.34986 15.6914 3.38094C15.9314 3.46512 16.149 3.60313 16.3275 3.78438C16.5059 3.96564 16.6405 4.18534 16.721 4.42665C16.8014 4.66795 16.8255 4.92447 16.7915 5.17655C16.7575 5.42863 16.6663 5.66958 16.5247 5.88094C16.5019 5.91508 16.4765 5.94748 16.4489 5.97788L12.4989 10.3228V15.834C12.4989 16.1496 12.3206 16.4382 12.0383 16.5793C11.756 16.7205 11.4181 16.69 11.1656 16.5007L7.83228 14.0007C7.62245 13.8433 7.49895 13.5963 7.49895 13.334V10.3228L3.549 5.97788C3.52137 5.94748 3.49602 5.91508 3.47316 5.88094C3.33164 5.66958 3.24039 5.42863 3.20637 5.17655C3.17236 4.92448 3.1965 4.66796 3.27693 4.42665C3.35737 4.18534 3.49197 3.96564 3.67043 3.78438C3.84889 3.60313 4.06646 3.46512 4.30649 3.38094ZM4.91305 5.00065L8.9489 9.44009C9.08835 9.59348 9.16562 9.79335 9.16562 10.0007V12.9173L10.8323 14.1673V10.0007C10.8323 9.79335 10.9096 9.59348 11.049 9.44009L15.0849 5.00065H4.91305Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.fcfa7d5fd9c422bc20c931291d699370.svg";
export { ForwardRef as ReactComponent };